import { ThemeVariants } from 'src/types'

export const getActiveTheme = (theme: ThemeVariants): ThemeVariants => {
  if (theme === ThemeVariants.SYSTEM) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? ThemeVariants.DARK
      : ThemeVariants.LIGHT
  }

  return theme
}
